import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["error", "className", "title", "name", "caption", "required", "defaultValue", "setYear", "setMonth", "setDay", "setValue", "forbidChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { forwardRef, useCallback, useEffect, useReducer } from "react";
import dayjs from "@/lib/day";
import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import SelectField from "./SelectField";
import ErrorMessage from "./ErrorMessage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function createOption(value, format) {
  return {
    value: value,
    label: "".concat(value).concat(format)
  };
}

function selectOption(type, value) {
  var options = function () {
    if (type === "year") return yearOptions();
    if (type === "month") return monthOptions();
    if (type === "day") return dayOptions();
  }();

  return options.find(function (option) {
    return option.value == value;
  });
}

var cachedOptions = {
  year: null,
  month: null,
  day: null
};

function yearOptions() {
  if (!cachedOptions.year) {
    var now = dayjs();
    var year = now.year();
    var minYear = 1900;
    var options = [];

    var _iterator = _createForOfIteratorHelper(Array(year - minYear + 1).keys()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var i = _step.value;
        var value = minYear + i;
        options.push(createOption(value, "年"));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    cachedOptions.year = options;
  }

  return cachedOptions.year;
}

function monthOptions() {
  if (!cachedOptions.month) {
    var options = [];

    var _iterator2 = _createForOfIteratorHelper(Array(12).keys()),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var i = _step2.value;
        var value = i + 1;
        options.push(createOption(value, "月"));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    cachedOptions.month = options;
  }

  return cachedOptions.month;
}

function dayOptions() {
  var daysInMonth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 31;

  if (!cachedOptions.day) {
    var options = [];

    var _iterator3 = _createForOfIteratorHelper(Array(daysInMonth).keys()),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var i = _step3.value;
        var value = i + 1;
        options.push(createOption(value, "日"));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    cachedOptions.day = options;
  }

  return cachedOptions.day;
}

function getBirthday(_ref) {
  var year = _ref.year,
      month = _ref.month,
      day = _ref.day;
  var date = dayjs("".concat(year, "-").concat(month, "-01"));
  var lastDay = date.daysInMonth();

  if (lastDay < day) {
    day = lastDay;
  }

  return dayjs("".concat(year, "-").concat(month, "-").concat(day));
}

var initialState = {
  birthday: "",
  daysInMonth: 31,
  year: "",
  month: "",
  day: ""
};
var BirthdayField = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;

  var error = props.error,
      className = props.className,
      title = props.title,
      name = props.name,
      caption = props.caption,
      required = props.required,
      defaultValue = props.defaultValue,
      setYear = props.setYear,
      setMonth = props.setMonth,
      setDay = props.setDay,
      setValue = props.setValue,
      forbidChange = props.forbidChange,
      _props = _objectWithoutProperties(props, _excluded);

  var updateState = useCallback(function (state, key, value) {
    var newState = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, key, value));

    var birthday = getBirthday(newState);
    var daysInMonth = birthday.daysInMonth();
    var formatBirthday = birthday.format("YYYY-MM-DD");
    return {
      birthday: formatBirthday,
      daysInMonth: daysInMonth,
      year: birthday.year(),
      month: birthday.month() + 1,
      day: birthday.date()
    };
  }, []);
  var reducer = useCallback(function (state, action) {
    switch (action.type) {
      case "year":
        return updateState(state, "year", action.value);

      case "month":
        return updateState(state, "month", action.value);

      case "day":
        return updateState(state, "day", action.value);

      default:
        return state;
    }
  }, []);

  var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var handleYearChange = useCallback(function (option) {
    dispatch({
      type: "year",
      value: option.value
    });

    if (setYear) {
      setYear(option.value);
    }
  }, []);
  var handleMonthChange = useCallback(function (option) {
    dispatch({
      type: "month",
      value: option.value
    });

    if (setMonth) {
      setMonth(option.value);
    }
  }, []);
  var handleDayChange = useCallback(function (option) {
    dispatch({
      type: "day",
      value: option.value
    });

    if (setDay) {
      setDay(option.value);
    }
  }, []);
  var handleYearMenuOpen = useCallback(function () {
    // 初期表示のときは1980年にスクロールする
    if (!state.year) {
      setTimeout(function () {
        var menu = document.querySelector(".react-select__menu-list");

        if (menu) {
          var option = menu.childNodes[80];
          menu.scrollTo(0, option.offsetTop);
        }
      });
    }
  }, [state.year]);
  useEffect(function () {
    if (defaultValue) {
      var valueList = defaultValue.split("-");

      var _valueList = _slicedToArray(valueList, 3),
          year = _valueList[0],
          month = _valueList[1],
          day = _valueList[2];

      dispatch({
        type: "year",
        value: year
      });
      dispatch({
        type: "month",
        value: month
      });
      dispatch({
        type: "day",
        value: day
      });
    }
  }, [defaultValue]);
  useEffect(function () {
    if (state.birthday.length > 0) {
      setValue(name, state.birthday);
      var input = document.querySelector("input[name=".concat(name, "]"));
      input.dispatchEvent(new Event("input", {
        bubbles: true
      }));
    }
  }, [state.birthday]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, (_classnames = {}, _defineProperty(_classnames, styles.required, required), _defineProperty(_classnames, styles.forbidChange, forbidChange), _classnames)),
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.formGroup,
      children: [/*#__PURE__*/_jsx(SelectField, _objectSpread({
        name: "".concat(name, "-y"),
        placeholder: "\u5E74",
        onChange: handleYearChange,
        options: yearOptions(),
        value: selectOption("year", state.year),
        onMenuOpen: handleYearMenuOpen
      }, _props)), /*#__PURE__*/_jsx(SelectField, _objectSpread({
        name: "".concat(name, "-m"),
        placeholder: "\u6708",
        onChange: handleMonthChange,
        options: monthOptions(),
        value: selectOption("month", state.month)
      }, _props)), /*#__PURE__*/_jsx(SelectField, _objectSpread({
        name: "".concat(name, "-d"),
        placeholder: "\u65E5",
        onChange: handleDayChange,
        options: dayOptions(state.daysInMonth),
        value: selectOption("day", state.day)
      }, _props))]
    }), /*#__PURE__*/_jsx("input", {
      type: "hidden",
      ref: ref,
      name: name,
      value: state.birthday
    }), caption && /*#__PURE__*/_jsx("p", {
      className: styles.caption,
      children: caption
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    })]
  });
});
BirthdayField.displayName = "BirthdayField";
export default BirthdayField;